<app-main-layout>
  <div class="bg-gray-50 min-h-screen">
  <div class="py-6 px-4 sm:px-6 max-w-[1400px] mx-auto">

    <!-- ============ HERO ============ -->
    <div class="relative overflow-hidden rounded-3xl bg-neutral-900 text-white px-6 sm:px-8 py-7 mb-6 shadow-lg">
      <div class="pointer-events-none absolute -right-16 -top-16 h-64 w-64 rounded-full bg-amber-400/20 blur-3xl"></div>
      <div class="pointer-events-none absolute right-10 bottom-0 opacity-[0.07]"><mat-icon class="!text-[160px] !h-[160px] !w-[160px]">sell</mat-icon></div>

      <div class="relative flex flex-col lg:flex-row lg:items-end justify-between gap-6">
        <div class="max-w-xl">
          <div class="inline-flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-[0.15em] text-amber-400">
            <mat-icon class="!text-[14px] !h-3.5 !w-3.5">inventory_2</mat-icon> Products
          </div>
          <h1 class="mt-2 text-3xl font-bold tracking-tight">Labels</h1>
          <p class="mt-2 text-sm text-white/60 leading-relaxed">The badges shown on product images - "NEW ARRIVAL", "Stock Clearance", offers. Add them to a product from its General tab.</p>
        </div>
        <button type="button"
          class="group self-start lg:self-auto flex items-center gap-2.5 pl-2.5 pr-5 py-2.5 rounded-2xl bg-amber-400 text-neutral-900 font-bold text-sm shadow-lg shadow-amber-500/20 hover:bg-amber-300 hover:-translate-y-0.5 active:translate-y-0 transition-all focus:outline-none focus:ring-4 focus:ring-amber-400/40"
          (click)="openCreate()">
          <span class="h-8 w-8 rounded-xl bg-neutral-900 text-amber-400 flex items-center justify-center transition-transform duration-200 group-hover:rotate-90">
            <mat-icon class="!text-[20px] !h-5 !w-5">add</mat-icon>
          </span>
          New label
        </button>
      </div>

      <div class="relative mt-7 grid grid-cols-2 sm:grid-cols-4 gap-3">
        @for (s of [
          { label: 'Labels', value: counts.total, icon: 'sell', filter: 'ALL' },
          { label: 'On products', value: counts.used, icon: 'check_circle', filter: 'USED' },
          { label: 'Not used', value: counts.unused, icon: 'label_off', filter: 'UNUSED' },
          { label: 'Products labelled', value: counts.onProducts, icon: 'inventory_2', filter: '' }
        ]; track s.label) {
        <button type="button" class="text-left rounded-2xl border px-4 py-3 transition-colors"
          [ngClass]="s.filter && filter === s.filter ? 'bg-amber-400/15 border-amber-400/50' : 'bg-white/[0.06] border-white/10 ' + (s.filter ? 'hover:bg-white/[0.1]' : 'cursor-default')"
          (click)="s.filter && (filter = $any(s.filter))">
          <div class="flex items-center gap-1.5 text-[11px] font-semibold text-white/50 uppercase tracking-wide"><mat-icon class="!text-[14px] !h-3.5 !w-3.5">{{ s.icon }}</mat-icon>{{ s.label }}</div>
          <div class="mt-1 text-2xl font-bold tabular-nums">{{ loading ? '–' : (s.value | number) }}</div>
        </button>
        }
      </div>
    </div>

    <!-- ============ TOOLBAR ============ -->
    <div class="sticky top-0 z-20 -mx-4 sm:mx-0 px-4 sm:px-0 py-3 mb-4 bg-gray-50/90 backdrop-blur">
      <div class="flex flex-col sm:flex-row sm:items-center gap-3">
        <div class="relative flex-1">
          <mat-icon class="absolute left-3.5 top-1/2 -translate-y-1/2 !text-gray-400 !text-[20px] !h-5 !w-5 pointer-events-none">search</mat-icon>
          <input type="text" placeholder="Search by name or label text…"
            class="w-full pl-11 pr-10 py-2.5 rounded-xl border border-gray-200 bg-white shadow-sm focus:border-amber-400 focus:ring-4 focus:ring-amber-100 outline-none transition-all text-sm"
            [(ngModel)]="search" />
          @if (search) {
          <button class="absolute right-2.5 top-1/2 -translate-y-1/2 h-7 w-7 rounded-full text-gray-400 hover:bg-gray-100 hover:text-gray-700 flex items-center justify-center" (click)="search = ''" aria-label="Clear search">
            <mat-icon class="!text-[18px] !h-[18px] !w-[18px]">close</mat-icon>
          </button>
          }
        </div>
        <div class="flex bg-white border border-gray-200 rounded-xl p-1 gap-1 shadow-sm self-start">
          @for (f of [{ key: 'ALL', label: 'All', n: counts.total }, { key: 'USED', label: 'On products', n: counts.used }, { key: 'UNUSED', label: 'Not used', n: counts.unused }]; track f.key) {
          <button class="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold transition-all"
            [ngClass]="filter === f.key ? 'bg-neutral-900 text-white shadow-sm' : 'text-gray-500 hover:text-gray-900 hover:bg-gray-50'" (click)="filter = $any(f.key)">
            {{ f.label }} <span class="tabular-nums" [ngClass]="filter === f.key ? 'text-amber-400' : 'text-gray-400'">{{ f.n }}</span>
          </button>
          }
        </div>
      </div>
    </div>

    @if (loadError) {
      <div class="mb-4 bg-red-50 border border-red-200 text-red-700 rounded-2xl p-4 text-sm flex items-center justify-between">
        <span class="flex items-center gap-2"><mat-icon class="!text-[18px] !h-[18px] !w-[18px]">cloud_off</mat-icon>Could not load labels from the server.</span>
        <button class="text-xs uppercase font-semibold underline" (click)="load()">Try again</button>
      </div>
    }

    <!-- ============ LIST ============ -->
    @if (loading) {
      <div class="flex flex-col gap-2.5">
        @for (i of [1, 2, 3, 4, 5, 6]; track i) {
        <div class="flex items-center gap-4 rounded-2xl bg-white border border-gray-100 px-5 py-3.5 animate-pulse">
          <div class="h-14 w-16 rounded-xl bg-gray-100"></div>
          <div class="flex-1"><div class="h-4 w-1/4 rounded bg-gray-100"></div><div class="mt-2 h-3 w-1/6 rounded bg-gray-100"></div></div>
          <div class="hidden md:block h-2 w-32 rounded-full bg-gray-100"></div>
        </div>
        }
      </div>
    } @else {
      @for (g of groups; track g.key) {
      <section class="mb-7 last:mb-0">
        <div class="flex items-center gap-3 mb-3 px-1">
          <span class="h-7 w-7 rounded-lg flex items-center justify-center" [ngClass]="g.key === 'USED' ? 'bg-amber-100 text-amber-700' : 'bg-gray-200 text-gray-600'">
            <mat-icon class="!text-[16px] !h-4 !w-4">{{ g.icon }}</mat-icon>
          </span>
          <span class="text-sm font-bold text-gray-900">{{ g.title }}</span>
          <span class="text-[11px] font-bold px-2 py-0.5 rounded-full bg-white border border-gray-200 text-gray-500 tabular-nums">{{ g.items.length }}</span>
          <span class="hidden lg:inline text-xs text-gray-400">{{ g.hint }}</span>
          <span class="flex-1 h-px bg-gradient-to-r from-gray-200 to-transparent"></span>
        </div>

        <div class="flex flex-col gap-2.5">
          @for (l of g.items; track l.id) {
          <div role="button" tabindex="0" (click)="view(l)" (keydown.enter)="view(l)"
            class="group grid grid-cols-[auto_minmax(0,1fr)_auto] md:grid-cols-[auto_minmax(0,1.4fr)_minmax(0,1fr)_200px_auto] gap-x-4 gap-y-3 items-center rounded-2xl bg-white border px-4 sm:px-5 py-3 cursor-pointer transition-all duration-200 hover:-translate-y-px hover:shadow-[0_8px_24px_-12px_rgba(0,0,0,0.18)] focus:outline-none focus-visible:ring-4 focus-visible:ring-amber-100"
            [ngClass]="selected?.id === l.id ? 'border-amber-300 ring-4 ring-amber-100/80' : 'border-gray-100 hover:border-gray-200'">

            <app-label-preview [title]="l.title" [text]="l.label" [bg]="l.bgColor" [fg]="l.textColor"></app-label-preview>

            <!-- Name + text -->
            <div class="min-w-0">
              <div class="text-[15px] font-semibold text-gray-900 truncate" [title]="l.title">{{ l.title }}</div>
              <div class="mt-1 flex items-center gap-1.5 min-w-0">
                <span class="text-[11px] text-gray-400 flex-shrink-0">Shows</span>
                <span class="text-xs font-bold px-2 py-0.5 rounded-md bg-gray-100 text-gray-800 truncate" [title]="l.label">{{ l.label }}</span>
              </div>
            </div>

            <!-- Actions (top right on phones) -->
            <div class="md:order-last flex items-center gap-0.5 rounded-xl bg-gray-50 border border-gray-100 p-0.5 md:opacity-0 md:group-hover:opacity-100 md:group-focus-within:opacity-100 transition-opacity"
              [class.md:opacity-100]="selected?.id === l.id">
              <button type="button" class="h-8 w-8 rounded-lg text-gray-500 hover:bg-white hover:text-gray-900 hover:shadow-sm flex items-center justify-center" matTooltip="View" (click)="$event.stopPropagation(); view(l)" aria-label="View"><mat-icon class="!text-[17px] !h-[17px] !w-[17px]">visibility</mat-icon></button>
              <button type="button" class="h-8 w-8 rounded-lg text-gray-500 hover:bg-white hover:text-gray-900 hover:shadow-sm flex items-center justify-center" matTooltip="Edit" (click)="openEdit(l, $event)" aria-label="Edit"><mat-icon class="!text-[17px] !h-[17px] !w-[17px]">edit</mat-icon></button>
              <span [matTooltip]="canDelete ? 'Delete' : 'Only admins can delete labels'">
                <button type="button" class="h-8 w-8 rounded-lg text-gray-500 hover:bg-red-50 hover:text-red-600 flex items-center justify-center disabled:opacity-30 disabled:pointer-events-none" [disabled]="!canDelete" (click)="remove(l, $event)" aria-label="Delete"><mat-icon class="!text-[17px] !h-[17px] !w-[17px]">delete</mat-icon></button>
              </span>
            </div>

            <!-- Style -->
            <div class="col-span-3 md:col-span-1 flex items-center gap-2 text-xs text-gray-500">
              @if (l.bgColor) {
                <span class="h-3 w-3 rounded-full flex-shrink-0 ring-1 ring-black/10" [style.background-color]="l.bgColor"></span>
                <span>Custom <span class="font-mono text-[11px] text-gray-400">{{ l.bgColor }}</span></span>
              } @else {
                <span class="h-2.5 w-2.5 rounded-full flex-shrink-0"
                  [ngClass]="labelStyle(l.title, l.label) === 'BESTSELLER' ? 'bg-[#3c8d40]' : labelStyle(l.title, l.label) === 'BLACK_FRIDAY' ? 'bg-black' : labelStyle(l.title, l.label) === 'SEALER' ? 'bg-[#f59e0b]' : 'bg-[#fdd835]'"></span>
                {{ styleNames[labelStyle(l.title, l.label)] }}
              }
            </div>

            <!-- Products -->
            <div class="col-span-3 md:col-span-1">
              @if (l.products) {
                <div class="flex items-baseline justify-between text-sm">
                  <span><span class="font-bold text-gray-900 tabular-nums">{{ l.products | number }}</span> <span class="text-gray-500">product{{ l.products === 1 ? '' : 's' }}</span></span>
                </div>
                <div class="mt-1.5 h-1.5 rounded-full bg-gray-100 overflow-hidden"><div class="h-full rounded-full bg-gradient-to-r from-amber-300 to-amber-500" [style.width.%]="Math.max((l.products / maxProducts) * 100, 3)"></div></div>
              } @else {
                <span class="inline-flex items-center gap-1 text-xs font-semibold px-2 py-0.5 rounded-md bg-gray-50 border border-dashed border-gray-200 text-gray-400">Not on any product</span>
              }
            </div>
          </div>
          }
        </div>
      </section>
      } @empty {
        <div class="rounded-3xl border-2 border-dashed border-gray-200 bg-white py-16 text-center">
          <span class="mx-auto h-14 w-14 rounded-2xl bg-amber-50 text-amber-600 flex items-center justify-center"><mat-icon class="!text-[28px] !h-7 !w-7">search_off</mat-icon></span>
          <p class="mt-3 text-sm font-semibold text-gray-700">No labels match</p>
          <p class="text-xs text-gray-400">Try another search or filter</p>
          @if (search || filter !== 'ALL') {
            <button type="button" class="mt-4 text-xs font-semibold text-amber-700 hover:underline" (click)="search = ''; filter = 'ALL'">Clear search and filter</button>
          }
        </div>
      }
    }
  </div>
  </div>

  <!-- ============ VIEW (slide-over) ============ -->
  @if (selected) {
  <div class="fixed inset-0 z-40 bg-black/30 backdrop-blur-[1px] lb-fade" (click)="selected = null"></div>
  <aside class="fixed inset-y-0 right-0 z-50 w-full max-w-md bg-white shadow-2xl flex flex-col lb-slide" role="dialog" aria-modal="true" aria-label="Label">
    <div class="relative overflow-hidden bg-neutral-900 text-white px-6 pt-6 pb-5">
      <div class="pointer-events-none absolute -right-10 -top-10 h-40 w-40 rounded-full bg-amber-400/20 blur-2xl"></div>
      <div class="relative flex items-start justify-between gap-3">
        <div class="min-w-0">
          <div class="text-[11px] font-bold uppercase tracking-[0.15em] text-amber-400">Label</div>
          <div class="mt-1.5 text-2xl font-bold leading-tight">{{ selected.title }}</div>
          <div class="mt-1 text-xs text-white/60">{{ selected.bgColor ? 'Custom colours' : styleNames[labelStyle(selected.title, selected.label)] }} on the product image</div>
        </div>
        <button type="button" class="h-9 w-9 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center flex-shrink-0" (click)="selected = null" aria-label="Close"><mat-icon class="!text-[18px] !h-[18px] !w-[18px]">close</mat-icon></button>
      </div>
      <div class="relative mt-4 grid grid-cols-[120px_minmax(0,1fr)] gap-4 items-center">
        <app-label-preview [title]="selected.title" [text]="selected.label" [bg]="selected.bgColor" [fg]="selected.textColor" size="lg"></app-label-preview>
        <div class="min-w-0">
          <div class="text-[10px] uppercase tracking-wide text-white/50">Text shown</div>
          <div class="text-sm font-bold break-words">{{ selected.label }}</div>
          <div class="mt-2 text-[10px] uppercase tracking-wide text-white/50">Products</div>
          <div class="text-lg font-bold tabular-nums">{{ selected.products | number }}</div>
        </div>
      </div>
      <div class="relative mt-4 flex gap-2">
        <button type="button" class="flex items-center gap-1.5 px-3.5 py-2 rounded-xl bg-amber-400 text-neutral-900 text-xs font-bold hover:bg-amber-300" (click)="openEdit(selected)"><mat-icon class="!text-[16px] !h-4 !w-4">edit</mat-icon>Edit</button>
        @if (canDelete) {
          <button type="button" class="flex items-center gap-1.5 px-3.5 py-2 rounded-xl bg-white/10 text-white text-xs font-semibold hover:bg-red-600" (click)="remove(selected)"><mat-icon class="!text-[16px] !h-4 !w-4">delete</mat-icon>Delete</button>
        }
      </div>
    </div>

    <div class="flex-1 min-h-0 flex flex-col px-6 py-5">
      <div class="flex items-center justify-between mb-3">
        <span class="text-[11px] font-bold uppercase tracking-wider text-gray-500">Products with this label</span>
        @if (products.length) { <span class="text-xs text-gray-400 tabular-nums">{{ visibleProducts.length }} of {{ products.length }}</span> }
      </div>
      @if (productsLoading) {
        <div class="flex-1 flex items-center justify-center"><mat-spinner diameter="26"></mat-spinner></div>
      } @else if (!products.length) {
        <div class="rounded-2xl bg-gray-50 py-10 text-center">
          <mat-icon class="!text-[30px] !h-[30px] !w-[30px] text-gray-300">label_off</mat-icon>
          <p class="mt-1 text-sm text-gray-500">No products carry this label</p>
          <p class="text-xs text-gray-400">Add it from a product's General tab</p>
        </div>
      } @else {
        <div class="relative mb-3">
          <mat-icon class="absolute left-3 top-1/2 -translate-y-1/2 !text-gray-400 !text-[18px] !h-[18px] !w-[18px] pointer-events-none">search</mat-icon>
          <input type="text" [(ngModel)]="productSearch" placeholder="Filter products"
            class="w-full pl-9 pr-3 py-2 rounded-xl border border-gray-200 bg-gray-50 text-sm outline-none focus:bg-white focus:border-amber-400 focus:ring-4 focus:ring-amber-100" />
        </div>
        <div class="flex-1 min-h-0 overflow-y-auto -mx-2 px-2">
          @for (p of visibleProducts; track p.productId) {
          <a class="group/item flex items-center gap-3 px-3 py-2.5 rounded-xl hover:bg-amber-50/70 transition-colors" [routerLink]="['/products/edit', p.productSlug]" target="_blank" rel="noopener">
            <span class="h-8 w-8 rounded-lg bg-gray-100 text-gray-400 group-hover/item:bg-amber-100 group-hover/item:text-amber-700 flex items-center justify-center flex-shrink-0"><mat-icon class="!text-[16px] !h-4 !w-4">inventory_2</mat-icon></span>
            <span class="min-w-0 flex-1 text-sm font-medium text-gray-800 truncate">{{ p.productName }}</span>
            @if (!p.active) { <span class="text-[10px] font-semibold px-1.5 py-0.5 rounded bg-gray-100 text-gray-500">Inactive</span> }
            <mat-icon class="!text-[16px] !h-4 !w-4 text-gray-300 group-hover/item:text-amber-600">open_in_new</mat-icon>
          </a>
          } @empty {
          <div class="py-8 text-center text-sm text-gray-400">No products match</div>
          }
        </div>
      }
    </div>
  </aside>
  }
</app-main-layout>
